import React from "react";

/** Colour + label helpers shared across all task UI.
 * Kept centralised so badges and Kanban headers never drift. */

export const PRIORITY_META = {
    Critical: { bg: "#FEE2E2", fg: "#991B1B", dot: "#DA3535", label: "Critical" },
    High:     { bg: "#FEF3C7", fg: "#92400E", dot: "#F59E0B", label: "High" },
    Normal:   { bg: "#DBEAFE", fg: "#1E40AF", dot: "#3B82F6", label: "Normal" },
    Low:      { bg: "#F1F5F9", fg: "#475569", dot: "#94A3B8", label: "Low" },
};

export const STATUS_META = {
    "Not Started": { bg: "#F1F5F9", fg: "#475569", dot: "#94A3B8" },
    "In Progress": { bg: "#DBEAFE", fg: "#1E40AF", dot: "#3B82F6" },
    "Waiting":     { bg: "#FEF3C7", fg: "#92400E", dot: "#F59E0B" },
    "Completed":   { bg: "#DCFCE7", fg: "#166534", dot: "#22C55E" },
    "Cancelled":   { bg: "#E5E7EB", fg: "#374151", dot: "#6B7280" },
};

export const KANBAN_COLUMNS = ["Not Started", "In Progress", "Waiting", "Completed"];

export function PriorityBadge({ priority = "Normal", small = false, testid }) {
    const m = PRIORITY_META[priority] || PRIORITY_META.Normal;
    return (
        <span
            className={`inline-flex items-center gap-1 rounded-full font-medium ${small ? "px-1.5 py-0.5 text-[10px]" : "px-2 py-0.5 text-xs"}`}
            style={{ background: m.bg, color: m.fg }}
            data-testid={testid}
        >
            <span className="w-1.5 h-1.5 rounded-full" style={{ background: m.dot }} />
            {m.label}
        </span>
    );
}

export function StatusBadge({ status = "Not Started", small = false, testid }) {
    const m = STATUS_META[status] || STATUS_META["Not Started"];
    return (
        <span
            className={`inline-flex items-center gap-1 rounded-full font-medium ${small ? "px-1.5 py-0.5 text-[10px]" : "px-2 py-0.5 text-xs"}`}
            style={{ background: m.bg, color: m.fg }}
            data-testid={testid}
        >
            <span className="w-1.5 h-1.5 rounded-full" style={{ background: m.dot }} />
            {status}
        </span>
    );
}

export function OverdueBadge({ small = false }) {
    return (
        <span
            className={`inline-flex items-center rounded-full font-medium bg-[#FEE2E2] text-[#991B1B] ${small ? "px-1.5 py-0.5 text-[10px]" : "px-2 py-0.5 text-xs"}`}
            data-testid="task-overdue-badge"
        >
            Overdue
        </span>
    );
}

export function formatDue(task) {
    if (!task?.due_date) return "";
    const d = new Date(task.due_date + "T00:00:00");
    const parts = d.toLocaleDateString(undefined, { day: "numeric", month: "short" });
    return task.due_time ? `${parts} · ${task.due_time}` : parts;
}
